export default {"src":"/_next/static/media/carousel-control.a317329c.svg","height":40,"width":40};